import {useAnalytics} from '@github-ui/use-analytics'
import {Button, Label} from '@primer/react'
import {type RefObject, useCallback, useRef} from 'react'

import type {CommentingImplementation, SuggestedChange} from '../../types'

export function CommitOrRemoveFromBatch({
  commentingImplementation,
  onOpenDialog,
  suggestedChange,
}: {
  commentingImplementation: CommentingImplementation
  onOpenDialog: (returnFocusRef?: RefObject<HTMLElement | null>) => void
  suggestedChange: SuggestedChange
}) {
  const returnFocusRef = useRef<HTMLButtonElement>(null)
  const batchCount = commentingImplementation.pendingSuggestedChangesBatch.length
  const {sendAnalyticsEvent} = useAnalytics()

  const handleCommitBatchClick = useCallback(() => {
    sendAnalyticsEvent('comments.commit_suggested_change_from_batch', 'COMMIT_SUGGESTED_CHANGE_FROM_BATCH_BUTTON', {
      commentKind: 'human',
      surface: 'commits',
    })
    onOpenDialog(returnFocusRef)
  }, [onOpenDialog, sendAnalyticsEvent])

  return (
    <div className="d-flex flex-row flex-justify-between">
      <Label variant="attention" className="my-auto">
        Pending in batch
      </Label>
      <div className="d-flex gap-2">
        <Button
          size="medium"
          variant="danger"
          onClick={() => {
            commentingImplementation.removeSuggestedChangeFromPendingBatch(suggestedChange)
            sendAnalyticsEvent(
              'comments.remove_suggested_change_from_batch',
              'REMOVE_SUGGESTED_CHANGE_FROM_BATCH_BUTTON',
              {commentKind: 'human', surface: 'commits'},
            )
          }}
        >
          Remove from batch
        </Button>
        <Button
          ref={returnFocusRef}
          size="medium"
          count={batchCount}
          variant="primary"
          onClick={handleCommitBatchClick}
        >
          {`Apply suggestion${batchCount > 1 ? 's' : ''}`}
        </Button>
      </div>
    </div>
  )
}
